"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.pass_reset.subject': 'Richiesta di Reimpostazione Password',
    'email.pass_reset.title': 'Reimposta La Tua Password',
    'email.pass_reset.text': 'Hai richiesto di reimpostare la tua password. Clicca il pulsante qui sotto per impostare una nuova password.',
    'email.pass_reset.button': 'Reimposta Password',
};
